<template>
    <div class="brt-map-floorModule" ref="floorModule">

        <div class="wrap">

            <div :class="scrollIndex==0 ? 'box up disabled':'box up' " @click ="scrollIndex==0 ?'':up()" v-if="queryFloor.length >5"><i class="iconfont icon-up-01"></i></div>

            <ul ref="scrollBox" :class="{oneChild:queryFloor.length==1}">
                <li :class="isTrue(item,index)" v-for="(item,index) in queryFloor" @click = "changeFloor(item,index)">{{item.floorName}}</li>
            </ul>

            <div :class="scrollIndex ==1 ? 'box down disabled':'box down'" @click ="scrollIndex==1?'':down()" v-if="queryFloor.length >5"><i class="iconfont icon-down-01"></i></div>

        </div>

    </div>
</template>

<script>

    // //模拟单店活动数据
    // let _data = [
    //     {
    //         poi:{
    //             CATEGORY_ID:"010100",
    //             CATEGORY_NAME:"中餐厅",
    //             FLOOR_ID:"00270007F01",
    //             FLOOR_NAME:"F1",
    //             FLOOR_NUMBER:1,
    //             LABEL_X:12738430.466525998,
    //             LABEL_Y:3582439.2799499473,
    //             NAME:"商业区",
    //             POI_ID:"00270007F0110228"
    //         },
    //
    //         active:{
    //             title:'万象彩妆课堂约会装——秒变冬万象彩妆课堂约会装——秒变冬万象彩妆课堂约会装——秒变冬',
    //             logo:'./images/poi_logo.png',
    //             NAME:'戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店戴森数码店',
    //             distant:100,
    //             slidIMGS:['./images/active.png','./images/active.png','./images/active.png'],
    //             tags:[
    //                 {
    //                     name:'满额即减',
    //                     content:'满2000减200'
    //                 }
    //             ],
    //             state:0     //0即将开始 1进行中 2已结束
    //         }
    //     },
    //
    //     {
    //         poi:{
    //             CATEGORY_ID:"110200",
    //             CATEGORY_NAME:"中餐厅",
    //             FLOOR_ID:"00270007F01",
    //             FLOOR_NAME:"F1",
    //             FLOOR_NUMBER:1,
    //             LABEL_X:12738315.225449998,
    //             LABEL_Y:3582471.7546443306,
    //             NAME:"C1到达区",
    //             POI_ID:"F1JC87"
    //         },
    //
    //         active:{
    //             title:'我是测试1111',
    //             logo:'./images/poi_logo.png',
    //             NAME:'这里是测试乐园',
    //             distant:100,
    //             slidIMGS:['./images/active.png'],
    //             tags:[
    //                 {
    //                     name:'满额即减',
    //                     content:'满2000减200'
    //                 },
    //                 {
    //                     name:'抵扣券',
    //                     content:'抵扣券499'
    //                 },
    //                 {
    //                     name:'到店赠礼品',
    //                     content:'到店赠礼品'
    //                 },
    //             ],
    //             state:0     //0即将开始 1进行中 2已结束
    //         }
    //     },
    // ];
    //
    // //模拟拼装店铺活动数据
    // let _$data={
    //
    //     total:145,
    //
    //     floors:[
    //         {
    //             floorName:'F1',
    //             floorNumber:1,
    //             floorID:'',
    //             activeData:_data,
    //         },
    //         {
    //             floorName:'F2',
    //             floorNumber:2,
    //             floorID:'',
    //             activeData:[],
    //         },
    //         {
    //             floorName:'F3',
    //             floorNumber:3,
    //             floorID:'',
    //             activeData:[],
    //         },
    //         {
    //             floorName:'F4',
    //             floorNumber:4,
    //             floorID:'',
    //             activeData:[],
    //         }
    //     ]
    //
    // }

    import { findCarParking_Null } from '@/config/prepare.js';
    import {_getPoiInfo} from "@/utils/search_poi_extend"

    import {_detailPoiExtend} from "@/utils/search_poi_extend";
    export default {
        name: "FloorModule",

        data(){
            return {
                queryIndex:0,
                queryFloor:[],

                scrollInit:false,      //滚动条初始化
                offsetIndex:0,        //向上向下移动距离
                scrollIndex:0,

                startFloor:null,           //起点楼层(暂时废弃)
                endFloor:null,             //终点楼层(暂时废弃)

                shopActiveData:'',

                initShopPoint:'',       //初始选点
            }
        },

        created(){
            //绑定店铺活动
            this.bus.$off('showShopActive')
            this.bus.$on('showShopActive',()=>{
                this.queryFloor = $VAR.map.mapInfoArray;
                this.initShopPoint = false;
                this.shopActiveDeal();
            })

            //切换楼层调整显示
            this.bus.$off('changeFloorInfo');
            let $this = this;
            this.bus.$on('changeFloorInfo',(res)=>{

                $this.queryFloor.map(function (item,index,self){

                    if(item.floorNumber == res.floor){
                        $this.queryIndex = index;
                        $this.scroll('select');

                    }
                })

            });

            //开启空车位
            this.bus.$off('onParkSpace');
            this.bus.$on('onParkSpace',res=>{

                if(res && res.status == 1){

                    this.$BRT.$urlParam.findNullPark.status = true;

                    if(res.floor){

                        let floorInfo = $VAR.map.getFloorInfoByIndex(res.floor);
                        if(!this.$store.state.park_NullData.length){
                            $VAR.map.setFloor(floorInfo.floorID,()=>{
                                this.getParkNull();
                            });

                        }else{
                            this.showParkNull(floorInfo.floorNumber);
                        }

                    }
                    else{

                        if(!this.$store.state.park_NullData.length){

                            this.getParkNull();

                        }else{
                            this.showParkNull();
                        }
                    }

                }

                else if(res.status == 2){
                    //清空图标
                    this.shopActiveEmpty();
                }

                else{
                    //恢复地图颜色
                    if(this.$store.state.park_NullData.length){

                        this.$store.state.park_NullData.map(item=>{

                            let parkPOIs = item.park.map(child=>{
                                return child.POI_ID;
                            })

                            $VAR.map.setFillColor(parkPOIs,'');
                        })

                        this.shopActiveEmpty();

                        //关闭空车位模式
                        this.$BRT.$urlParam.findNullPark.status = false;
                    }
                }
            });

            this.bus.$off('FloorModuleListenFLoor');
            this.bus.$on('FloorModuleListenFLoor',res=>{
                this.floorIndex(res.floorNumber);
            })
        },

        methods:{

            //向上
            up(){
                this.scroll('up')
            },

            //向下
            down(){
                this.scroll('down')
            },

            //滚动
            scroll(type){

                let $this=this,$cur_scoll,
                    $ul_H = $this.$refs.scrollBox.offsetHeight,
                    $ul_SH=$this.$refs.scrollBox.scrollHeight,
                    $stopScroll=null,
                    $clickscroll=false; //滚动触发

                if(type == 'init'){

                    $this.offsetIndex =$this.queryFloor.length -  $this.queryIndex;

                    //设置滚动
                    if($this.queryIndex >= 2){
                        $this.$refs.scrollBox.scrollTop = $this.$refs.scrollBox.childNodes[$this.queryIndex-2].offsetTop
                    }

                    if($this.queryIndex < 5){
                        $this.scrollIndex = 0;//到顶
                    }

                    if(this.offsetIndex < 5){
                        $this.scrollIndex = 1;//到底
                    }

                    if($this.queryIndex>5 && this.offsetIndex >5){
                        $this.scrollIndex = 2;
                    }

                    //开启监听
                    $this.$refs.scrollBox.addEventListener('scroll',function () {

                        //检测停止滚动(+-5是容错)
                        if(!$clickscroll && ($this.$refs.scrollBox.scrollTop > $cur_scoll-5) && ($this.$refs.scrollBox.scrollTop < $cur_scoll+5)){

                            if(!$this.scrollInit){$this.scrollInit = true}

                            if($stopScroll){clearTimeout($stopScroll)}  //防止重复

                            $stopScroll = setTimeout(function () {

                                if(($this.$refs.scrollBox.scrollTop > $cur_scoll-5) && ($this.$refs.scrollBox.scrollTop < $cur_scoll+5)){

                                    for(let i=0; i<$this.$refs.scrollBox.childNodes.length-1;i++){

                                        if($this.$refs.scrollBox.childNodes[i].offsetTop > $this.$refs.scrollBox.scrollTop){
                                            $this.offsetIndex = i;
                                            break;
                                        }
                                    }
                                }
                            },10)
                        }

                        $cur_scoll = $this.$refs.scrollBox.scrollTop;

                        if($cur_scoll <= 5){

                            $this.scrollIndex = 0;//到顶

                        }

                        else if($ul_SH - $cur_scoll- $ul_H <= 5){

                            $this.scrollIndex = 1;//到底

                        }

                        else{
                            $this.scrollIndex = 2;
                        }

                    })
                }else{

                    $clickscroll=true;

                    //设置到选中项
                    let $index = 0;

                    //向上
                    if(type =='up'){

                        if(!$this.scrollInit){
                            $this.offsetIndex = $this.queryIndex;
                            $this.scrollInit = true;
                        }

                        for(let i = 5; i>0 ;i--){

                            if($this.offsetIndex - i >= 0){
                                $index = $this.offsetIndex -i;break;
                            }

                        }

                        $this.offsetIndex = $index;

                        // console.log('$this.offsetIndex2',$this.offsetIndex);

                        let scrollUpTime = setInterval(function () {

                            if($this.$refs.scrollBox.scrollTop<=0 || $this.$refs.scrollBox.scrollTop <= $this.$refs.scrollBox.childNodes[$index].offsetTop){
                                $clickscroll=false;
                                clearInterval(scrollUpTime);
                                return;
                            }

                            $this.$refs.scrollBox.scrollTop -= 10;

                        },10)

                    //向下
                    }

                    else if(type=='down'){

                        if(!$this.scrollInit){
                            $this.offsetIndex = $this.queryIndex;
                            $this.scrollInit = true;
                        }

                        for(let i=5;i >=0;i--){if( $this.offsetIndex +i <= $this.$refs.scrollBox.childNodes.length-1){$index = $this.offsetIndex +i;break;}}
                        $this.offsetIndex =$index;
                        // console.log('$this.offsetIndex3',$this.offsetIndex);
                        let scrollDownTime = setInterval(function () {

                            if( $this.$refs.scrollBox.scrollTop > ($this.$refs.scrollBox.childNodes[$this.queryFloor.length -5].offsetTop-5) || $this.$refs.scrollBox.scrollTop > ($this.$refs.scrollBox.childNodes[$index].offsetTop-5)){

                                $clickscroll=false;
                                clearInterval(scrollDownTime);
                                return;
                            }

                            $this.$refs.scrollBox.scrollTop += 10;

                        },10)

                        //其他方式
                    }

                    else if(type == 'select'){

                        setTimeout(()=>{   //防止初始节点未加载被执行

                            //居中显示
                            if($this.queryFloor.length > 5 && $this.queryIndex > 2 &&  $this.queryIndex < $this.queryFloor.length-3){
                                $this.$refs.scrollBox.scrollTop=$this.$refs.scrollBox.childNodes[$this.queryIndex].offsetTop - $ul_H/2 + $this.$refs.scrollBox.childNodes[0].offsetHeight/2;
                            }

                        },0)

                    }
                }
            },

            changeFloor(item,index){

                // console.log('item',item);
                let $this =this,$brtmap=$this.$store.state.mapStore.brtmap;

                if($brtmap.$locate.point && item.floorNumber == $brtmap.$locate.point.floor){

                    $brtmap.$locate.allowFloor  = true;

                }else{

                    $brtmap.$locate.allowFloor  = false;

                }

                $this.queryIndex = index;
                $this.scroll('select');

                let $zoom = $VAR.map.getZoom();
                $VAR.map.setFloor(item.mapID,()=>{

                    /********虚拟定位点*********/
                    if(!this.$mapStep.type && $brtmap.$locate.point){

                        $VAR.map.stop().easeTo({
                            zoom:$zoom,
                            //center:[$brtmap.$locate.point.lng,$brtmap.$locate.point.lat]   //不规整建筑会存在bug [$VAR.map.building.longitude,$VAR.map.building.latitude]   [$brtmap.$locate.point.lng,$brtmap.$locate.point.lat]
                        })

                    }else{

                        $VAR.map.stop().easeTo({
                            zoom:$zoom
                        })

                    }
                });



            },

            shopActiveEmpty(){
                //先清空图标
                for(let i=0;i<$VAR.shopMakers.length;i++){
                    $VAR.shopMakers[i].maker.empty();
                }
                $VAR.shopMakers = [];

                this.$BRT.$active.shopPoint = '';
            },

            shopActiveDeal(){

                let callback = ()=>{
                    if(this.initShopPoint)return false;
                    this.initShopPoint = true;

                    //先清空图标
                    for(let i=0;i<$VAR.shopMakers.length;i++){
                        $VAR.shopMakers[i].maker.empty();
                    }

                    $VAR.shopMakers = [];

                    //匹配楼层
                    this.shopActiveData=[];

                    //初始拦截(链接进入)
                    if(this.$BRT.$urlParam.shopActive.selete){

                        //拿到选中数据
                        this.initShopPoint =  this.$store.state.ACTIVITY_DATA.filter((item)=>{
                            return item.id == this.$BRT.$urlParam.shopActive.selete
                        })

                        this.$BRT.$urlParam.shopActive.selete = '';

                        if(this.initShopPoint.length > 0){

                            this.initShopPoint = this.initShopPoint[0];
                            this.initShopPoint.FLOOR_NUMBER = this.initShopPoint.FLOOR_NUMBER ? this.initShopPoint.FLOOR_NUMBER : this.initShopPoint.poi.FLOOR_NUMBER;
                            //楼层是否匹配
                            if($VAR.map.currentMapInfo.floorNumber != this.initShopPoint.FLOOR_NUMBER){

                                this.initShopPoint.FLOOR_ID = this.initShopPoint.FLOOR_ID ? this.initShopPoint.FLOOR_ID : this.initShopPoint.poi.FLOOR_ID;

                                let $zoom = $VAR.map.getZoom();
                                $VAR.map.setFloor(this.initShopPoint.FLOOR_ID,()=>{
                                    $VAR.map.stop().easeTo({
                                        zoom:$zoom
                                    })
                                });
                            }
                        }

                        else{

                            this.$message.load();
                            this.$message.info('暂无该企业参与活动');
                            this.$mapStep.type = '';
                            this.$BRT.$urlParam.shopActive.selete = '';

                        }
                    }
                    else{
                        this.$message.load()
                    }


                    let floors = this.$BRT.$active.shopDatas.floors;


                    if(floors){

                        for(let i=0;i<floors.length;i++){
                            if($VAR.map.currentMapInfo.floorNumber == floors[i].floorNumber){
                                this.shopActiveData = floors[i].activeData
                            }
                        }

                        if(this.shopActiveData.length == 0){
                            this.$message.info('本楼层无活动,请选择有小圆点楼层');
                            return;
                        }

                        //插标
                        let $makers = [];

                        for(let i = 0;i<this.shopActiveData.length;i++){

                            let lngLat = $VAR.map.coordsToLnglat(this.shopActiveData[i].poi.LABEL_X,this.shopActiveData[i].poi.LABEL_Y),
                                $content = '';

                            //匹配经纬度
                            this.shopActiveData[i].poi.LngLat = lngLat;

                            //匹配点位详情
                            _detailPoiExtend([this.shopActiveData[i].poi], this.$store.state.POI_DETAIL_DATA);

                            //营业时间
                            let obj = this.shopActiveData[i].poi;
                            if(obj.detail && obj.detail.bussT){

                                let str = '',weekArr = obj.detail.bussT.week;

                                while (weekArr.length){str += weekArr.splice(0,1) + '、'}

                                str = str.slice(0,str.length-1);

                                if(obj.detail.bussT.sTime && obj.detail.bussT.eTime){
                                    str += ' '+obj.detail.bussT.sTime + '~' + obj.detail.bussT.eTime;
                                }
                                obj.detail.bussStr = str;
                            }

                            //获取距离
                            this.bus.$emit('getDistant',{
                                type:1,
                                point:this.shopActiveData[i].poi,
                                callback:(data)=>{

                                    this.shopActiveData[i].active.distance = data ? data.distance : null;

                                    this.shopActiveData[i].poi.distance = data ? data.distance : 0;
                                }
                            })

                            //内容拼装
                            // for(let j=0;j<this.shopActiveData[i].active.tags.length;j++){
                            //
                            //     if(!!this.shopActiveData[i].active.tags[j].content){
                            //         $content = $content + '<p>' + this.shopActiveData[i].active.tags[j].content + '</p>'
                            //     }
                            //
                            // }

                            $content=`<img src="${this.shopActiveData[i].active.Data.imgUrl}">`

                            let $maker = new brtmap.Symbol.DivMarker({
                                content:'<div class="wrap">'+ $content +'</div>',
                                className:'shop-marker',
                            }).addTo($VAR.map);

                            $maker.setLnglat(lngLat);

                            //第一个显示移动地图
                            if(i==0){$VAR.map.easeTo({center:lngLat})}


                            let _callabck = ()=>{
                                //阻止冒泡
                                // event.stopPropagation();
                                //移除选中标签
                                for(let k=0;k<$VAR.shopMakers.length;k++){$VAR.shopMakers[k].maker.removeClass('active');}

                                $maker.addClass('active');

                                this.$BRT.$active.shopPoint = this.shopActiveData[i];

                                $VAR.map.easeTo({
                                    zoom:JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank ? JSON.parse(this.$mapStore.plugInfo.plugInfo.plugInSettings.navigation).defaultRank :19,
                                    center:lngLat
                                })
                            }

                            //绑定事件
                            $maker.on('click',()=>{

                                _callabck && _callabck();
                            });

                            //初始执行
                            if(this.shopActiveData[i].active.Data.id == this.initShopPoint.id){
                                this.$message.load(false);
                                _callabck && _callabck();
                            }

                            $makers.push({active:this.shopActiveData[i],maker:$maker})
                        }

                        //注册全局
                        $VAR.shopMakers = $makers;

                    }
                }

                if(!this.$mapEventManger.mapQueryStatus){

                    this.$mapEventManger.mapQueryEvents.push(()=>{
                        callback && callback();
                    })

                }
                else{
                    callback && callback();
                }
            },

            //复杂判断
            isTrue(item,index){

                let $this=this, str = '';

                if(index == $this.queryIndex)str='active';

                //起终点
                // if($this.startFloor && item.floorNumber == $this.startFloor)str+=' start';
                // if($this.endFloor && item.floorNumber == $this.endFloor)str+=' end';
                // if(str.match('start end'))str+=' startAndEnd';
                // return str;

                //店铺活动小红点处理
                if(this.$mapStep.type == "shopActive"){

                    if(this.$BRT.$active.shopDatas.floors){
                        for(let i=0;i<this.$BRT.$active.shopDatas.floors.length;i++){

                            if(this.$BRT.$active.shopDatas.floors[i].floorNumber == item.floorNumber){

                                str +=' end'
                            }

                        }
                    }

                }

                return str;
            },

            //空车位
            showParkNull(floor){

                floor = floor || $VAR.map.currentMapInfo.floorNumber;

                let $setpark = this.$store.state.park_NullData.filter((item)=>{return item.floor == floor})

                if($setpark.length > 0){

                    $setpark = $setpark[0].park;

                    //筛选出POI
                    let $setparkPOI = $setpark.map((item)=>{return item.POI_ID});

                    $VAR.map.setFillColor($setparkPOI,'#19be6b');
                }

                //关闭遮罩
                if(this.$BRT.$urlParam.findNullPark.status){
                    this.$message.load(false)
                }


            },

            getParkNull(floor,callback){

                let $brtmap = this.$BRT,
                    isFirst = true;

                //获取空车位数据
                findCarParking_Null(this,res=>{

                    if(res.data.code == 0){

                        let $result = [];

                        /*******数据处理*******/
                        for(let i=0;i<res.data.result.length;i++){
                            $result.push({
                                POI_ID:res.data.result[i]
                            })
                        }

                        _getPoiInfo(this.$brtmap,$result)

                        //POI
                        $result = $result.map(item=>{return item.poi});

                        //防止为空
                        $result = $result.filter(item=>{return !!item});

                        let $data = $result,
                            $parkData=[];

                        //按楼层组装数据
                        for(var i=0;i<$VAR.map.mapInfoArray.length;i++){

                            let $floor = $VAR.map.mapInfoArray[i].floorNumber,
                                $park = [];

                            $park = $data.filter((item)=>{return item.FLOOR_NUMBER == $floor});

                            if($park.length > 0){$parkData.push({floor:$floor,floorID:$VAR.map.mapInfoArray[i].floorID,park:$park})}

                        }

                        //保存空车位数据
                        if(!this.$store.state.park_NullData.length){

                            this.$store.state.park_NullData = $parkData;

                        }else{

                            //融合数据

                            let sp = this.$store.state.park_NullData;
                            for(let i=0;i<$parkData.length;i++){
                                let p = $parkData[i],
                                    spIndex = -1;

                                let isExits = sp.some((item,index)=>{

                                    if(item.floor === p.floor)spIndex = index;

                                    return item.floor == p.floor
                                })

                                if(isExits){
                                    sp[spIndex].park = sp[spIndex].park.concat(p.park)
                                }
                                else{
                                   sp.push(p)
                                }
                            }
                        }


                        if($parkData.length > 0){

                            if($parkData[0].floor != $VAR.map.currentMapInfo.floorNumber){

                                if(floor){
                                    $VAR.map.setFloor($parkData[0].floorID,()=>{ this.showParkNull(floor)})
                                }else{
                                    //初次允许切换
                                    if(isFirst){
                                        isFirst = false;
                                        $VAR.map.setFloor($parkData[0].floorID,()=>{ this.showParkNull($parkData[0].floor)})
                                    }
                                }

                            }else{

                                $VAR.map.setFloor($parkData[0].floorID,()=>{ this.showParkNull($parkData[0].floor)})
                            }
                        }

                    }

                    else{

                        this.$message.info('获取空车位数据失败');
                        this.$message.load(false);
                        this.$BRT.$urlParam.findNullPark.status = false;

                    }

                })

            },

            floorIndex(v1,v2){

                let $this = this;

                // if($this.queryIndex == v1)return;//防止重复操作（本组件）
                $this.queryFloor.map(function (item,index,self){

                    if(item.floorNumber == v1){

                        $this.queryIndex = index;
                        $this.scroll('select');

                    }

                })

                if(this.$mapStep.type == 'shopActive'){
                    this.initShopPoint = false;
                    this.shopActiveDeal();
                }

                //空车位
                if(this.$BRT.$urlParam.findNullPark.status){this.showParkNull(v1)}
            }
        },


        watch:{
            $mapStepType(v1,v2){
                //销毁
                if(v1 !='shopActive'){this.shopActiveEmpty();}
            }
        },

        computed:{


            $mapStepType(){
                return this.$mapStep.type
            },
        },

        mounted(){

            let $brtmap = this.$store.state.mapStore.brtmap;

            this.queryFloor = $VAR.map.mapInfoArray;

            //排序
            this.queryFloor = this.queryFloor.sort((v1,v2)=>{
                return v2.floorNumber - v1.floorNumber;
            })

            //初始选中显示
            this.queryFloor.map((item,index,self)=>{

                if(item.floorNumber == $VAR.map.currentMapInfo.floorNumber){

                    this.queryIndex = index;
                }

            })


            //初始化滚动条
            setTimeout(()=>{
                if(this.queryFloor.length > 5){
                    this.offsetIndex = this.queryIndex;
                    this.scroll('init')
                }
            },0)


            //接入寻找空车位
            if(this.$BRT.$urlParam.findNullPark.status){
                //$VAR.map.setFloor('05120011B02'); //默认b2空车位楼层
                if(this.$store.state.park_NullData.length ==  0){this.getParkNull()}
            }
        }
    }
</script>

<style lang="less">
    @import "FloorModule.less";
</style>
